import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ErrorOutline } from "@mui/icons-material";

import { useAudienceMutations } from "@/hooks";
import { DialogComponentProps } from "@/context";

type CloneAudienceDialogProps = DialogComponentProps<"cloneAudience">;

const CloneAudienceDialog: React.FC<CloneAudienceDialogProps> = ({
  audience,
  open,
  onClose,
}) => {

  const { clone, action } = useAudienceMutations(audience);

  return (
    <Dialog open={open} disableEnforceFocus aria-labelledby="delete-dialog">
      <DialogTitle>
        <Typography>Clone Audience</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>
          Please confirm you wish to clone <b>{audience.audience_name}</b> as a new audience.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={"contained"}
          size={"small"}
          onClick={clone}
          loading={action.status === 'loading'}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneAudienceDialog;
